export default "<div ui-view></div>";